import {APIPlatformSerializer} from './abstract';
import {PROVIDER} from '../../../resources';

export class PreferenceSerializer extends APIPlatformSerializer {
  base = `/${PROVIDER.PREFERENCES}`;
}
